export default __webpack_public_path__ + "static/media/placeholder_dummy2016-architekturbuero01-monbile-de.34b7ae40.png";